import { render } from "./CreateWifiAPSuccess.vue?vue&type=template&id=50830640"
import script from "./CreateWifiAPSuccess.vue?vue&type=script&lang=ts"
export * from "./CreateWifiAPSuccess.vue?vue&type=script&lang=ts"
script.render = render

export default script